module.exports = __webpack_public_path__ + "img/tuto_mobile_way_01_01.95a876ee.png";